"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.socialNames = void 0;
var socialNames = ['facebook', 'instagram', 'linkedin', 'pinterest', 'youtube', 'twitter'];
exports.socialNames = socialNames;